var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import ReactivateMagicLinkButton from './ReactivateMagicLinkButton.vue';
import EditClaimButton from '@backoffice/components/claim/ManagementBar/EditClaimButton.vue';
import ExpertAppointmentButton from '@backoffice/components/claim/ManagementBar/ExpertAppointmentButton.vue';
import SetManagementButton from '@backoffice/components/claim/ManagementBar/SetManagementButton.vue';
import ArtisanAppointmentButton from '@backoffice/components/claim/ManagementBar/ArtisanAppointmentButton.vue';
import CloseClaimButton from '@backoffice/components/claim/ManagementBar/CloseClaimButton.vue';
import { UserRole } from '@shared/types/api/user';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
import CloseClaimManagementButton from '@backoffice/components/claim/ManagementBar/CloseClaimManagementButton.vue';
import OpenSelfcareButton from '@backoffice/components/claim/ManagementBar/OpenSelfcareButton.vue';
import { ClaimStatus, ExitTypes } from '@shared/types/api/claim';
let ManagementBar = class ManagementBar extends Vue {
    get canCloseFromCloseManagementButton() {
        return (this.$hasAccessLevel(UserRole.MANAGER_READONLY) &&
            insurerHasFeature(InsurerFeatureFlag.CloseClaimDirectlyFromManagementBar));
    }
    get canOpenInSelfcare() {
        return this.$hasAccessLevel(UserRole.MANAGER);
    }
    get canReactivateMagicLink() {
        var _a;
        const claim = (_a = this.$store.state.claim.info) === null || _a === void 0 ? void 0 : _a.claim;
        const isManager = this.$hasAccessLevel(UserRole.MANAGER);
        const isNoAdminFollowup = (claim === null || claim === void 0 ? void 0 : claim.status) === ClaimStatus.NoAdministrativeFollowUp && (claim === null || claim === void 0 ? void 0 : claim.exit) === ExitTypes.NoFollowUp;
        return isManager && isNoAdminFollowup;
    }
};
__decorate([
    Prop({ type: Boolean, default: true })
], ManagementBar.prototype, "canEdit", void 0);
ManagementBar = __decorate([
    Component({
        components: {
            CloseClaimManagementButton,
            OpenSelfcareButton,
            EditClaimButton,
            ExpertAppointmentButton,
            SetManagementButton,
            ArtisanAppointmentButton,
            CloseClaimButton,
            ReactivateMagicLinkButton,
        },
    })
], ManagementBar);
export default ManagementBar;
